<template>
    <grid-component
        isResizable
        isReorderable
        isSortable
        :gridId="gridId"
        :pageable="pageable"
        :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
        :take="pageInfo.pageSize"
        :itemData="itemData"
        :pageSizes="pageInfo.pageSize"
        :totalItems="pageInfo.totalItems"
        :fields="fields"
        :sortBy="pageInfo.sortBy"
        :sortOrder="pageInfo.sortOrder"
        :onDelete="onDelete"
        :styleCustom="'height: 335px'"
        :isTblLoader="tblLoader"
        :handleRowClick="handleRowClick"
    />
</template>

<script>
import GridComponent from '@/shared/components/GridComponent';
import { DEFAULT_SORT_BY, DEFAULT_SORT_ORDER, GRID_PAGE_SIZES } from '@/shared/constants';
import { mapState } from 'vuex';

export default {
    components: {
        GridComponent    
    },
    props: {
        gridId: {
            type: String,
            default: ''
        },
        pageInfo: {
            type: Object,
            default: () => {
                return {
                    totalItems: 0,
                    totalPages: 0,
                    pageNumber: 1,
                    sortBy: DEFAULT_SORT_BY,
                    sortOrder: DEFAULT_SORT_ORDER,    
                }
            }
        },
        itemData: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Array,
            default: () => []
        },
        sortGrid: {
            type: Function
        },
        onDelete: {
            type: Function
        },
        onGetData: {
            type: Function
        },
        handleRowClick: {
            type: Function
        }
    },
    data() {
        return {
            pageable: {
                pageSizes: GRID_PAGE_SIZES
            }
        }
    },
    computed: {
        ...mapState('commission', ['tblLoader'])
    }
    
}
</script>